<template>
  <div v-if="aml">
    <div class="d-flex justify-content-between align-items-start mb-3">
      <div>
        <p class="fw-bold text-xs mb-1">AML Verification – Results</p>
      </div>
    </div>

    <!-- Summary Cards -->
    <div class="row g-2 mb-4">
      <div
        class="col-md-4"
        v-for="item in summaryCards"
        :key="item.label"
      >
        <div class="border rounded-3 p-3 text-center h-100 bg-white">
          <i :class="item.icon + ' fs-4 mb-1 text-primary'"></i>
          <p class="text-xxs text-muted mb-1">{{ item.label }}</p>
          <p class="fw-bold mb-0">{{ item.value }}</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
function safeValue(val) {
  return val ?? 0;
}

export default {
  name: "AMLDashboardResults",
  props: {
    aml: { type: Object, required: true },
    date: { type: String, default: "" }
  },
  computed: {
    summaryCards() {
      return [
        { label: "Politically Exposed Persons", value: safeValue(this.aml.pep_count), icon: "bi-person-check" },
        { label: "Sanctions", value: safeValue(this.aml.sanctions_count), icon: "bi-shield-exclamation" },
        { label: "Enforcement Actions", value: safeValue(this.aml.enforcement_count), icon: "fa-solid fa-scale-balanced" },
        { label: "Adverse Media", value: safeValue(this.aml.adverse_media_count), icon: "bi-newspaper" },
        { label: "Associated Persons", value: safeValue(this.aml.associated_persons_count), icon: "bi-people" }
      ];
    }
  }
};
</script>